import { action, createRequestTypes } from '../base';

export const busyIntegrationActionTypes = {
  GET_BUSY_CONNECTIONS: createRequestTypes('GET_BUSY_CONNECTIONS'),
  DELETE_BUSY_CONNECTION: createRequestTypes('DELETE_BUSY_CONNECTION'),
  CONNECT_TO_BUSY: createRequestTypes('CONNECT_TO_BUSY'),
  SYNC_BUSY_PRODUCT: createRequestTypes('SYNC_BUSY_PRODUCT'),
  SYNC_BUSY_CUSTOMER: createRequestTypes('SYNC_BUSY_CUSTOMER'),
  REFRESH_BUSY_CONNECTIONS: createRequestTypes('REFRESH_BUSY_CONNECTIONS'),
  CONNECT_TO_BUSY_LOCATION: createRequestTypes('CONNECT_TO_BUSY_LOCATION'),
  PUSH_GRN_TO_BUSY: createRequestTypes('PUSH_GRN_TO_BUSY'),
  PUSH_INVOICE_TO_BUSY: createRequestTypes('PUSH_INVOICE_TO_BUSY'),
  PUSH_EXPENSE_TO_BUSY: createRequestTypes('PUSH_EXPENSE_TO_BUSY'),
  PUSH_CREDIT_NOTE_TO_BUSY: createRequestTypes('PUSH_CREDIT_NOTE_TO_BUSY'),
  PUSH_DEBIT_NOTE_TO_BUSY: createRequestTypes('PUSH_DEBIT_NOTE_TO_BUSY'),
};

class BusyIntegrationActions {
  // get busy connections
  getBusyConnections = (orgId, callback) => action(busyIntegrationActionTypes.GET_BUSY_CONNECTIONS.REQUEST, {
    orgId, callback,
  })

  getBusyConnectionsLoading = (getBusyConnectionsLoading) => action(busyIntegrationActionTypes.GET_BUSY_CONNECTIONS.LOADING, {
    getBusyConnectionsLoading,
  })

  getBusyConnectionsSuccess = (busyConnections) => action(busyIntegrationActionTypes.GET_BUSY_CONNECTIONS.SUCCESS, {
    busyConnections,
  })

  // delete busy connection
  deleteBusyConnection = (payload, callback) => action(busyIntegrationActionTypes.DELETE_BUSY_CONNECTION.REQUEST, {
    payload, callback,
  })

  deleteBusyConnectionLoading = (deleteBusyConnectionLoading) => action(busyIntegrationActionTypes.DELETE_BUSY_CONNECTION.LOADING, {
    deleteBusyConnectionLoading,
  })

  // connect to busy
  connectToBusy = (payload, callback) => action(busyIntegrationActionTypes.CONNECT_TO_BUSY.REQUEST, {
    payload, callback,
  })

  connectToBusyLoading = (connectToBusyLoading) => action(busyIntegrationActionTypes.CONNECT_TO_BUSY.LOADING, {
    connectToBusyLoading,
  })

  // sync busy product
  syncProduct = (payload, callback) => action(busyIntegrationActionTypes.SYNC_BUSY_PRODUCT.REQUEST, {
    payload, callback,
  })

  syncProductLoading = (syncProductLoading) => action(busyIntegrationActionTypes.SYNC_BUSY_PRODUCT.LOADING, {
    syncProductLoading,
  })

  // sync busy customer
  syncVendor = (payload, callback) => action(busyIntegrationActionTypes.SYNC_BUSY_CUSTOMER.REQUEST, {
    payload, callback,
  })

  syncVendorLoading = (syncVendorLoading) => action(busyIntegrationActionTypes.SYNC_BUSY_CUSTOMER.LOADING, {
    syncVendorLoading,
  })

  // refresh busy connection
  refreshBusyConnections = (payload, callback) => action(busyIntegrationActionTypes.REFRESH_BUSY_CONNECTIONS.REQUEST, {
    payload, callback,
  })

  refreshBusyConnectionsLoading = (refreshBusyConnectionsLoading) => action(busyIntegrationActionTypes.REFRESH_BUSY_CONNECTIONS.LOADING, {
    refreshBusyConnectionsLoading,
  })

  // connect to busy location
  connectToBusyLocation = (payload, callback) => action(busyIntegrationActionTypes.CONNECT_TO_BUSY_LOCATION.REQUEST, {
    payload, callback,
  })

  connectToBusyLocationLoading = (connectToBusyLocationLoading) => action(busyIntegrationActionTypes.CONNECT_TO_BUSY_LOCATION.LOADING, {
    connectToBusyLocationLoading,
  })

  // push grn to busy

  pushGrnToBusy = (payload, callback) => action(busyIntegrationActionTypes.PUSH_GRN_TO_BUSY.REQUEST, {
    payload, callback,
  })

  pushGrnToBusyLoading = (pushGrnToBusyLoading) => action(busyIntegrationActionTypes.PUSH_GRN_TO_BUSY.LOADING, {
    pushGrnToBusyLoading,
  })

  // push invoice to busy

  pushInvoiceToBusy = (payload, callback) => action(busyIntegrationActionTypes.PUSH_INVOICE_TO_BUSY.REQUEST, {
    payload, callback,
  })

  pushInvoiceToBusyLoading = (pushInvoiceToBusyLoading) => action(busyIntegrationActionTypes.PUSH_INVOICE_TO_BUSY.LOADING, {
    pushInvoiceToBusyLoading,
  })

  // push expense to busy
  pushExpenseToBusy = (payload, callback) => action(busyIntegrationActionTypes.PUSH_EXPENSE_TO_BUSY.REQUEST, {
    payload, callback,
  })

  pushExpenseToBusyLoading = (pushExpenseToBusyLoading) => action(busyIntegrationActionTypes.PUSH_EXPENSE_TO_BUSY.LOADING, {
    pushExpenseToBusyLoading,
  })

  // push credit note to busy

  pushCreditNoteToBusy = (payload, callback) => action(busyIntegrationActionTypes.PUSH_CREDIT_NOTE_TO_BUSY.REQUEST, {
    payload, callback,
  })

  pushCreditNoteToBusyLoading = (pushCreditNoteToBusyLoading) => action(busyIntegrationActionTypes.PUSH_CREDIT_NOTE_TO_BUSY.LOADING, {
    pushCreditNoteToBusyLoading,
  })

  // push debit note to busy

  pushDebitNoteToBusy = (payload, callback) => action(busyIntegrationActionTypes.PUSH_DEBIT_NOTE_TO_BUSY.REQUEST, {
    payload, callback,
  })

  pushDebitNoteToBusyLoading = (pushDebitNoteToBusyLoading) => action(busyIntegrationActionTypes.PUSH_DEBIT_NOTE_TO_BUSY.LOADING, {
    pushDebitNoteToBusyLoading,
  })
}

export default new BusyIntegrationActions();
